import {
  FURROW_LITE_FAILED,
  FURROW_LITE_REQUEST,
  FURROW_LITE_SUCCESS,
} from "app/redux/actions/SeriesProduct/FurrowLite/constant";

const INIT_STATE = {
  loading: false,
  totalPage: 0,
  data: [],
  error: {
    isError: false,
    message: null,
  },
};

export const furrowLiteReducer = function (state = INIT_STATE, action) {
  switch (action?.type) {
    case FURROW_LITE_REQUEST:
      return {
        loading: true,
        totalPage: 0,
        data: [],
        error: {
          isError: false,
          message: null,
        },
      };
    case FURROW_LITE_SUCCESS:
      return {
        loading: false,
        data: action?.payload?.data,
        totalPage: action?.payload?.totalPage,
        error: {
          isError: false,
          message: null,
        },
      };
    case FURROW_LITE_FAILED:
      const { isError = true, message = "Something Went Wrong" } =
        action?.payload?.error || {};
      return {
        loading: false,
        totalPage: 0,
        data: [],
        error: {
          isError: isError,
          message: message,
        },
      };
    default:
      return state;
  }
};
